import React from 'react';
import { TableCell } from '@material-ui/core';
import classNames from 'classnames';

import { RaceCompetitor } from 'src/interfaces/RacingState';
import useIsMobile from 'src/hooks/useIsMobile';

interface QuickBetHorseCellProps {
  onClick: (e) => void, // eslint-disable-line no-unused-vars
  competitor: RaceCompetitor,
  ellipseName?: boolean,
  expanded?: boolean,
  checkCompetitor?: boolean,
  official?: boolean
}

export default function QuickBetHorseCell({
  onClick,
  competitor,
  ellipseName = false,
  expanded = false,
  checkCompetitor,
  official
}: QuickBetHorseCellProps) {
  const mobile = useIsMobile();

  return (
    <TableCell onClick={ onClick } >
      <div className="competitors-table__name-number">
        <div className={
          classNames({
            'competitors-table__horse-name': true,
            'competitors-table__horse-name--ellipsed': ellipseName
          })
        }
        >{ competitor.horse ? competitor.horse.name : '' }</div>
        <div
          className={ mobile ? 'competitors-table__expand-quick' : 'competitors-table__expand' }
        >
          { checkCompetitor && !official ? (expanded ? '—' : '+') : '' }
        </div>
      </div>
    </TableCell>
  );
}
